import { render, staticRenderFns } from "./outChannelCommission.vue?vue&type=template&id=b1624c0c&scoped=true"
import script from "./outChannelCommission?vue&type=script&lang=js&external"
export * from "./outChannelCommission?vue&type=script&lang=js&external"
import style0 from "./outChannelCommission.vue?vue&type=style&index=0&id=b1624c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1624c0c",
  null
  
)

export default component.exports